import * as React from 'react';
import { Pill, type PillTone } from './pill';
import { roleTone } from '@/lib/api/services/settings';

/**
 * RoleBadge — renders an RBAC role as a status pill via the shared `roleTone`
 * map (10-settings.md §"Shared components"). Used on Users and Departments.
 */
export function RoleBadge({ role, className }: { role: string; className?: string }) {
  const tone = (roleTone[role] ?? 'neutral') as PillTone;
  return (
    <Pill tone={tone} className={cnFont(className)}>
      {role}
    </Pill>
  );
}

function cnFont(className?: string) {
  return ['font-mono lowercase', className].filter(Boolean).join(' ');
}
